import { Box, styled } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { UploadFileIcon } from '@setvi/shared/components/sicons';

const Container = styled(Box)({
  top: '0%',
  left: '0%',
  width: '100%',
  height: '100%',
  position: 'absolute',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  border: '2px dashed #256EE4',
  borderRadius: 12,
  zIndex: 2,
  transition: 'all 0.3s ease'
});

const Content = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gridGap: 12
});

const DNDOverlay = ({ visible }: { visible: boolean }) => (
  <Container
    style={{
      visibility: visible ? 'visible' : 'hidden',
      opacity: visible ? 1 : 0
    }}>
    <Content>
      <UploadFileIcon
        style={{
          height: 60,
          width: 60
        }}
        fontSize="large"
        color="primary"
      />

      <SText weight="bold" size="lg" title="Drag & Drop" />
      <SText title="Drop your image here to upload" />
    </Content>
  </Container>
);

export default DNDOverlay;
